import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #b0b0b0;
  height: 12px;
  width: 8px;
`
export const KeyboardArrowIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.92187 1.40625L3.32812 6L7.92187 10.5937L6.51562 12L0.515624 6L6.51562 -4.36431e-07L7.92187 1.40625Z"
        fill="#B0B0B0"
      />
    </Svg>
  )
}
